export enum PUBLIC_ROUTES {
  PUBLIC = 'public',
  DOCUMENT_SIGNATURE = 'document-signature',
}
